import { useEffect, useState } from "react";
import { FileSearch, FileText, ShieldAlert, Sparkles } from "lucide-react";

const STEPS = [
  { icon: FileSearch, text: "Contract scannen..." },
  { icon: FileText, text: "Kleine lettertjes lezen..." },
  { icon: ShieldAlert, text: "Tarieven en risico's vergelijken..." },
  { icon: Sparkles, text: "Rapport opmaken..." },
];

export default function LoadingState() {
  const [step, setStep] = useState(0);
  const [progress, setProgress] = useState(6);

  useEffect(() => {
    const stepTimer = setInterval(() => {
      setStep((s) => (s + 1) % STEPS.length);
    }, 2200);
    const progressTimer = setInterval(() => {
      setProgress((p) => (p >= 92 ? 92 : p + Math.random() * 6));
    }, 700);
    return () => {
      clearInterval(stepTimer);
      clearInterval(progressTimer);
    };
  }, []);

  const Icon = STEPS[step].icon;

  return (
    <section
      className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-24"
      data-testid="loading-state"
    >
      <div className="max-w-xl mx-auto bg-white border border-slate-200 rounded-2xl shadow-[0_2px_30px_rgba(15,23,42,0.06)] p-10 text-center">
        <div className="relative mx-auto h-24 w-24 mb-6">
          <span className="pulse-ring" />
          <span className="pulse-ring" style={{ animationDelay: "0.6s" }} />
          <span className="pulse-ring" style={{ animationDelay: "1.2s" }} />
          <div className="absolute inset-2 bg-blue-700 rounded-full grid place-items-center shadow-lg shadow-blue-500/30">
            <Icon className="h-8 w-8 text-white" />
          </div>
        </div>
        <h3 className="font-heading font-bold text-2xl text-slate-900" data-testid="loading-title">
          Je contract wordt geanalyseerd
        </h3>
        <p className="mt-2 text-slate-600 transition-all" data-testid="loading-step">
          {STEPS[step].text}
        </p>

        <div className="mt-7 h-2 w-full rounded-full bg-slate-100 overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-blue-600 to-emerald-500 rounded-full transition-[width] duration-500 ease-out"
            style={{ width: `${progress}%` }}
            data-testid="loading-progress-bar"
          />
        </div>
        <div className="mt-3 text-xs text-slate-500" data-testid="loading-progress-percent">
          {Math.round(progress)}% — meestal binnen 30 seconden
        </div>
      </div>
    </section>
  );
}
